module.exports = __webpack_public_path__ + "img/20191123151317994.23184ec1.jpg";